export const SELECT = "SELECT"
export const DESELECT = "DESELECT"
export const LOADING = "LOADING"
export const COPY_TO_ALL_STUDENTS = "COPY_TO_ALL_STUDENTS"
